module.exports = __webpack_public_path__ + "static/media/instagram.0915e385.png";